import { render, staticRenderFns } from "./detail-header.vue?vue&type=template&id=9368bd08"
import script from "./detail-header.vue?vue&type=script&lang=js"
export * from "./detail-header.vue?vue&type=script&lang=js"
import style0 from "./detail-header.vue?vue&type=style&index=0&id=9368bd08&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports